import sendSelectItemEvent from '../../flow/gtm/sendSelectItemEvent';
import { RuntimeClientAtom } from '@vs-shop/engine/runtime/RuntimeClient';

export const sendSelectItemEventAtomFn = RuntimeClientAtom.fn(sendSelectItemEvent);
